import React from "react";
import { R$ } from "../utils/brl";
import moment from 'moment';

function RifaInfoCard({ title, description, image, value, prize, raffleTime, dateOptions, minimumAvailableQuotas, hideImage, hideTitle, hideDetails }) {
  return (
    <header className="game-info">
      { hideImage ? null : <img src={image} className="game-info__image" /> }
      <div className="game-info__content">
        <div className="game-info__text">
          { hideTitle ? null : <h1 className="game-info__text__title rifa-title">{title}</h1> }
          {description && <p className="game-info__text__description" dangerouslySetInnerHTML={{ __html: description }}></p>}
        </div>
        <div className="game-info__cards">
          <div className="game-info__card">
            { hideDetails ? null : <React.Fragment>
              <p className="game-info__card__title">Valor da cota {R$(value)}</p>
              <p className="game-info__card__title">{`Data do sorteio ${moment(dateOptions[0]).format('DD/MM/YYYY')}`}</p>
            </React.Fragment>}
          </div>
        </div>
      </div>
    </header>
  );
}

export default RifaInfoCard;



// WEBPACK FOOTER //
// ./src/rifa/components/rifaInfoCard.jsx